import { render, staticRenderFns } from "./CallcentreTeamList.vue?vue&type=template&id=533423cb&"
import script from "./CallcentreTeamList.vue?vue&type=script&lang=js&"
export * from "./CallcentreTeamList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports